import { useEffect } from "react";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { getMe } from "../../../../../Store/Slices/authSlice";
import { useEditUserDataMutation } from "../../../../../API/authApi";
import { useGeneralHooks, useToastify } from "../../../../../Hooks/hooks"
import { IEditUserForm } from "../../../../../Interfaces/formValue-interfaces";
import { IEditUserData } from "../../../../../Interfaces/request-interfaces";
import { IGetMe } from "../../../../../Interfaces/responseTypes";

const useUserDataHooks = (onClose: () => void) => {
    const { currentUser, dispatch, t } = useGeneralHooks();
    const [edit, { isLoading, isSuccess, isError }] = useEditUserDataMutation();
    const { showToastSuccess, showToastError } = useToastify();
    const { register, handleSubmit, control, formState: { errors }, reset, } = useForm<IEditUserForm>();

    useEffect(() => {
        if (isSuccess) {
            onClose()!;
            dispatch(getMe());
            showToastSuccess(t('Toast.Success.Common'))
        } else if (isError) {
            showToastError(t('Toast.Error.Common'))
        }
    }, [isSuccess, isError]);

    useEffect(() => {
        const user = currentUser as IGetMe;
        const userData: IEditUserForm = {
            first_name: user?.user?.first_name || user?.user?.username || "",
            last_name: user?.user?.last_name || "",
            phone_number: user.phone_number,
        };
        reset(userData);
    }, [currentUser, reset]);

    const onCloseDialog = () => {
        onClose()!;
        reset()
    };

    const onSubmit: SubmitHandler<IEditUserForm | FieldValues> = (values) => {
        const payload: IEditUserData = {
            user: {
                first_name: values.first_name,
                last_name: values.last_name
            },
            phone_number: values.phone_number,
            user_role: (currentUser as IGetMe).user_role!
        };
        edit(payload)
    };

    return {
        register,
        handleSubmit,
        onCloseDialog,
        onSubmit,
        control,
        errors,
        currentUser,
        isLoading,
    }
};

export default useUserDataHooks